import { CountryPath } from "src/entities/CountryPath";

export const getCountryTimezone = (country: CountryPath): string => {
  switch (country) {
    case "IDN":
      return "Asia/Jakarta"; // UTC+7
    case "SGP":
      return "Asia/Singapore"; // UTC+8
    case "PHL":
      return "Asia/Manila"; // UTC+8
    case "MYS":
      return "Asia/Kuala_Lumpur"; // UTC+8
    case "THA":
      return "Asia/Bangkok"; // UTC+7
    case "VNM":
      return "Asia/Ho_Chi_Minh"; // UTC+7
    case "AUS":
      return "Australia/Sydney"; // UTC+10/11 (DST)
    case "USA":
      return "America/New_York"; // UTC-5/-4 (DST)
    case "JPN":
      return "Asia/Tokyo"; // UTC+9
    default:
      return "Asia/Jakarta";
  }
};

export const getCountryTimezoneAbbreviation = (
  country: CountryPath
): string => {
  switch (country) {
    case "IDN":
      return "WIB"; // Western Indonesia Time
    case "SGP":
      return "SGT"; // Singapore Time
    case "PHL":
      return "PHT"; // Philippine Time
    case "MYS":
      return "MYT"; // Malaysia Time
    case "THA":
      return "ICT"; // Indochina Time
    case "VNM":
      return "ICT"; // Indochina Time
    case "AUS":
      return "AEDT/AEST"; // Australian Eastern Daylight/Standard Time
    case "USA":
      return "EDT/EST"; // Eastern Daylight/Standard Time
    case "JPN":
      return "JST"; // Japan Standard Time
    default:
      return "WIB";
  }
};
